import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputText, TextValueAccessor, Button, Icon } from '@shui/angular';
import {
    createAdditionalContactFormGroup,
    createContactInformationFormGroup,
    ContactInformationFormGroup
} from '../../models/contact-information.model';

@Component({
    selector: 'app-contact-information',
    templateUrl: './contact-information.component.html',
    imports: [TranslateModule, ReactiveFormsModule, InputText, TextValueAccessor, Button, Icon],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContactInformationForm {
    public showContinue = input<boolean>(true);
    public requestId = input<string>();
    public loading = input<boolean>(false);
    public continue = output<void>();
    public saveChanged = output<void>();
    public submitChanged = output<void>();
    public deleteChanged = output<void>();

    private translateService = inject(TranslateService);

    public formGroup: FormGroup<ContactInformationFormGroup> = createContactInformationFormGroup();

    public get additionalContacts(): ReturnType<
        typeof createContactInformationFormGroup
    >['controls']['additionalContacts'] {
        return this.formGroup.controls.additionalContacts;
    }

    protected addContact(): void {
        this.additionalContacts.push(createAdditionalContactFormGroup());
    }

    protected removeContact(index: number): void {
        this.additionalContacts.removeAt(index);
    }

    public getErrorMessage(controlName: string): string {
        const control = this.formGroup.get(controlName);
        if (!control?.errors) return '';
        if (control.errors['required']) return this.translateService.instant('common.validation.required');
        if (control.errors['email']) return this.translateService.instant('common.validation.invalidEmail');
        return '';
    }

    protected onSave(): void {
        this.saveChanged.emit();
    }

    protected onSubmit(): void {
        this.submitChanged.emit();
    }

    protected onDelete(): void {
        this.deleteChanged.emit();
    }

    protected onContinue(): void {
        this.continue.emit();
    }
}
